/**
 * @generated SignedSource<<df85299ab68d619de7e5d65f07a01eb8>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "CreateTagPayload",
            "kind": "LinkedField",
            "name": "createTag",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfTag",
                    "kind": "LinkedField",
                    "name": "tagEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Tag",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useTags_createTagMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useTags_createTagMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "e6c1eb8211c5421e1291c77c46695200",
            "id": null,
            "metadata": {},
            "name": "useTags_createTagMutation",
            "operationKind": "mutation",
            "text": "mutation useTags_createTagMutation(\n  $model: CreateTagRequestInput!\n) {\n  createTag(model: $model) {\n    tagEdge {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "32499a52b2de24d405283724fd7643c2";
export default node;
